// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"9d1aee58","879":"d578e1f4","977":"af8ba294"}[chunkId] + ".chunk.js";
};